const SPIRAL_UPDATE_EVENT = 'spiral-angle-update';

export const updateSpiralAngle = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SPIRAL_UPDATE_EVENT));
  }
};

// Export event name for consistency
export { SPIRAL_UPDATE_EVENT };
